import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { getEventMarketingCampaignState } from 'api/models'

import { TickWrappedIcon } from 'images'

export default function EventHeaderDefault({ event, showActiveBadge = true, children = null, renderMenu }) {
  const { t } = useTranslation()

  const { hasMarketingCampaign, hasActiveCampaign } = useMemo(() => getEventMarketingCampaignState(event), [event])

  if (!event) return null

  console.log('event', event)

  return (
    <>
      <div className="row">
        <div className="col">
          <h1 className="event-title" title={event.title}>
            {event.title}
          </h1>

          {children}

          {showActiveBadge && hasMarketingCampaign && (
            <span
              className={`event-row_left-content_title-and-date_date_active-campaign-indicator_wrapper ${hasActiveCampaign ? 'green' : 'red'}`}
              style={{ marginLeft: 0, height: '20px' }}
            >
              <span>
                <TickWrappedIcon width={12} />
              </span>

              <span className="event-row_left-content_title-and-date_date_active-campaign-indicator_text">
                {hasActiveCampaign
                  ? t('Recommendations.campaignBadge.active')
                  : t('Recommendations.campaignBadge.inactive')}
              </span>
            </span>
          )}
        </div>
      </div>
      {renderMenu && renderMenu()}
    </>
  )
}

EventHeaderDefault.propTypes = {
  event: PropTypes.object.isRequired,
  menuOptions: PropTypes.array,
  showActiveBadge: PropTypes.bool,
  children: PropTypes.node,
  renderMenu: PropTypes.func,
}
